// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"17dfc83f","649":"b6d5b71b"}[chunkId] + ".chunk.css";
};